import { Icon, Flex, useDisclosure } from '@chakra-ui/react';
import { AiOutlineQuestionCircle } from 'react-icons/ai';
import { BsCircleHalf } from 'react-icons/bs';
import { FaHashtag, FaRegStar } from 'react-icons/fa';
import { IoMdCheckbox } from 'react-icons/io';
import { MdOutlineRadioButtonChecked } from 'react-icons/md';
import { v4 as uuidv4 } from 'uuid';
import { Popover } from '@/components/ats';
import { PlusCircle } from '@kula-ai/icons/dual-tone/PlusCircle';
import { KText } from '@/ui-library/components/text/KText';

const questions = [
  { id: 'star', label: 'Score (stars)', icon: FaRegStar },
  { id: 'one_to_ten', label: 'Score (1 to 10)', icon: FaHashtag },
  { id: 'yes_no', label: 'Yes/No', icon: BsCircleHalf },
  {
    id: 'open_question',
    label: 'Open question',
    icon: AiOutlineQuestionCircle,
  },
  {
    id: 'multiple_choice',
    label: 'Single select',
    icon: MdOutlineRadioButtonChecked,
  },
  { id: 'checkbox', label: 'Multiple select', icon: IoMdCheckbox },
];

export const AddQuestion = ({ formRef }) => {
  const popoverActions = useDisclosure();

  const clickHandler = (item) => {
    const id = uuidv4();
    const alreadyPresentScoreCards = formRef?.current?.values?.scoreCards || [];

    const newQuestion = {
      id: id,
      question: '',
      type: item?.id,
      options:
        item?.id === 'multiple_choice' || item?.id === 'checkbox'
          ? [{ optionText: '' }, { optionText: '' }]
          : undefined,
    };
    const updatedScoreCards = [newQuestion, ...alreadyPresentScoreCards];
    const currentValues = formRef?.current?.values || {};
    formRef?.current?.setValues(
      {
        ...currentValues,
        scoreCards: updatedScoreCards,
      },
      false
    );
    if (formRef?.current?.errors?.scoreCards) {
      formRef?.current?.setErrors({});
    }
    popoverActions.onClose();
  };

  const renderTrigger = () => {
    return (
      <Flex
        gap="6px"
        justifyContent="center"
        alignItems="center"
        cursor="pointer"
        p="14px"
        borderRadius="xs"
        bg="primary-25"
        my="12px"
        data-test-id="add-score-card-question"
      >
        <Icon as={PlusCircle} h="18px" w="18px" color="primary-500"></Icon>
        <KText color="primary-600" size="sm-medium">
          Add question
        </KText>
      </Flex>
    );
  };

  const renderContent = () => {
    return (
      <Flex flexDirection="column" gap="6px">
        {questions?.map((item) => (
          <Flex
            key={item?.id}
            alignItems="center"
            gap="12px"
            cursor="pointer"
            p="10px"
            onClick={() => clickHandler(item)}
            data-test-id={item?.id}
          >
            <Icon
              // @ts-ignore
              as={item?.icon}
              color="secondary-700"
            />
            <KText>{item?.label}</KText>
          </Flex>
        ))}
      </Flex>
    );
  };

  return (
    <Popover
      triggerElement={renderTrigger()}
      children={renderContent()}
      popoverActions={popoverActions}
      showArrow={false}
      showCloseButton={false}
    ></Popover>
  );
};
